import { render, staticRenderFns } from "./CloudRec.vue?vue&type=template&id=ff7fad12&"
import script from "./CloudRec.vue?vue&type=script&lang=js&"
export * from "./CloudRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports